import _get from 'lodash/get';
import axios from 'axios';
import Page from '../../lib/page';
import { trackLink } from '../../lib/analytics-helper';
import * as types from '../constants/ActionTypes';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const emailByPassPage = 'emailByPassPage';

function requestIDIContactOptions() {
  return {
    type: types.REQUEST_IDI_CONTACT_OPTIONS,
  };
}

function receivedIDIContactOptionsError() {
  return {
    type: types.RECEIVE_IDI_CONTACT_OPTIONS_ERROR,
  };
}

// Passing IDI channels(contact options) to redux state
function receivedIDIContactOptions(IDIChannels) {
  return {
    type: types.RECEIVE_IDI_CONTACT_OPTIONS_RESPONSE,
    payload: IDIChannels,
  };
}

// Send IDI Post request to IDI server
function userSelectionPostRequest(kanaCode, topicName) {
  return axios.post('/smarthelp/update-user-selection', {
    _csrf: Page.getCSRFtoken(),
    topicId: kanaCode,
    topicName,
  });
}

// Update User Selection for both Login and Logout users
function updateUserSelection(id) {
  return (dispatch, getState) => {
    const { topicName } = getState().selectResult.topicTreeSelectResult;
    const kanaCode = id === emailByPassPage ? getState().emailNoIntent.kanaCode : getState().emailForm.kanaCode;
    trackLink({ id, link: `smarthelp-topic-update-idi|${kanaCode}|` });

    const postRequest = userSelectionPostRequest(kanaCode, topicName);

    // Using remote config to control IDI contact options display logic
    if (Page.getIsIDIContactOptions()) {
      postRequest.then((response) => {
        dispatch(requestIDIContactOptions());
        const IDIChannels = _get(response, 'data');
        if (Array.isArray(IDIChannels) && IDIChannels.length > 0) {
          dispatch(receivedIDIContactOptions(IDIChannels));
        } else {
          dispatch(receivedIDIContactOptionsError());
        }
      });
      postRequest.catch(() => dispatch(receivedIDIContactOptionsError()));
    }
    return postRequest;
  };
}

module.exports = {
  updateUserSelection,
};
